<div class="center-content-area">
    <h2 class="center-page-heading">{{ "help_support_heading_page" | translate }}</h2>
    <p class="center-page-description">{{ "help_support_description" | translate }}</p>

    <div class="flex flex-row flex-md-row mb-6 gap-4">
        <div class="my-6">
            <p-card
                header="{{ 'help_support_card_documentation_heading' | translate }}"
                subheader="{{ 'help_support_card_documentation_subheading' | translate }}"
                [style]="{ width: '360px' }"
                styleClass="p-card-shadow"
            >
                <ng-template pTemplate="header">
                    <img alt="Card" src="/assets/images/pages/integration/documentation.png" />
                </ng-template>
                <p>{{ "help_support_card_documentation_description" | translate }}</p>
                <ng-template pTemplate="footer">
                    <p-button label="{{ 'button_help_support_card_documentation_watch' | translate }}" icon="pi pi-book" (click)="openDoc()"></p-button>
                </ng-template>
            </p-card>
        </div>

        <div class="my-6">
            <p-card
                header="{{ 'help_support_card_video_tutorial_heading' | translate }}"
                subheader="{{ 'help_support_card_video_tutorial_subheading' | translate }}"
                [style]="{ width: '360px' }"
                styleClass="p-card-shadow"
            >
                <ng-template pTemplate="header">
                    <img alt="Card" src="/assets/images/pages/integration/video-tutorials.png" />
                </ng-template>
                <p>{{ "help_support_card_video_tutorial_description" | translate }}</p>
                <ng-template pTemplate="footer">
                    <p-button label="{{ 'button_help_support_card_video_tutorial_watch' | translate }}" icon="pi pi-video" (click)="openTutorial()"></p-button>
                </ng-template>
            </p-card>
        </div>
    </div>

    <div class="mx-2 mt-6 mb-12">
        <h5>{{ "help_questions_heading" | translate }}</h5>
        <p>{{ "help_questions_description" | translate }}</p>
        <ul>
            <p-button label="{{ 'help_questions_contact' | translate }}" styleClass="p-button-link" (click)="linkToSupport()"></p-button>
        </ul>
    </div>
</div>
